const STANDARD_MATERIALS = [
    {
        category: 'Tocht & isolatie',
        items: [
            { title: 'Tochtband rubber', unit: 'meter' },
            { title: 'Tochtband schuim', unit: 'meter' },
            { title: 'Tochtstrip onderdeur', unit: 'stuks' },
            { title: 'Aluminium kaderprofiel', unit: 'stuks' },
            { title: 'Kunststof kaderprofiel', unit: 'stuks' },
            { title: 'Brievenbusborstel', unit: 'stuks' },
            { title: 'Brievenbusborstel aluminium', unit: 'stuks' },
            { title: 'Kit (transparant)', unit: 'koker' },
            { title: 'Kit (wit)', unit: 'koker' },
            { title: 'Dorpel', unit: 'stuks' },
            { title: 'Dorpelprofiel borstel', unit: 'stuks' },
            { title: 'Dorpelprofiel rubber', unit: 'stuks' },
            { title: 'Deursluiter Axa', unit: 'stuks' },
            { title: 'Deursluiter Opdekdeur', unit: 'stuks' },
            { title: 'Kozijnfolie', unit: 'rol' },
            { title: 'Setje magneten', unit: 'set' },
            { title: 'Gordijn', unit: 'stuks' },
        ],
    },
    {
        category: 'Verwarming & energie',
        items: [
            { title: 'Radiatorfolie', unit: 'rol' },
            { title: 'Ontluchtsleutel radiator', unit: 'stuks' },
            { title: 'Verlengstuk radiatorventilator', unit: 'stuks' },
        ],
    },
    {
        category: 'Elektriciteit',
        items: [
            { title: 'LED-lamp E27', unit: 'stuks' },
            { title: 'LED-lamp E14', unit: 'stuks' },
            { title: 'LED-lamp GU10', unit: 'stuks' },
            { title: 'LED-lamp E14 - 1W', unit: 'stuks' },
            { title: 'LED-lamp E14 - 2W', unit: 'stuks' },
            { title: 'LED-lamp E14 - 4W', unit: 'stuks' },
            { title: 'LED-lamp E27 - 1W', unit: 'stuks' },
            { title: 'LED-lamp E27 - 3W', unit: 'stuks' },
            { title: 'LED-lamp E27 - 5W', unit: 'stuks' },
            { title: 'LED-lamp E27 - 7,5W', unit: 'stuks' },
            { title: 'LED-lamp E27 - 10,5 W', unit: 'stuks' },
            { title: 'LED-lamp G9 - 1,8W', unit: 'stuks' },
            { title: 'LED-lamp G9 - 3,5W', unit: 'stuks' },
            { title: 'LED-lamp GU10 - 3,5W', unit: 'stuks' },
            { title: 'Tijdschakelaar', unit: 'stuks' },
            { title: 'Bewegingssensor', unit: 'stuks' },
            { title: 'Tafelcontactdoos met schakelaar', unit: 'stuks' },
        ],
    },
    {
        category: 'Waterbesparing & comfort',
        items: [
            { title: 'Waterbesparende douchekop', unit: 'stuks' },
            { title: 'Perlator (kraan)', unit: 'stuks' },
            { title: 'Vensterbankrooster', unit: 'stuks' },
            { title: 'Radiatorventilator', unit: 'stuks' },
            { title: 'Raamfolie (enkelglas)', unit: 'rol' },
            { title: 'Douchetimer - zandloper', unit: 'stuks' },
            { title: 'Douchetimer - digitaal', unit: 'stuks' },
            { title: 'Sokken', unit: 'paar' },
        ],
    },
]

const UNIT_BY_TITLE = new Map(
    STANDARD_MATERIALS.flatMap((c) => c.items.map((i) => [i.title, i.unit]))
)

export const STANDARD_MATERIAL_OPTIONS = STANDARD_MATERIALS.flatMap((c) =>
    c.items.map((i) => `${i.title} - ${c.category}`)
)

export const parseMaterialOption = (rawValue) => {
    const value = (rawValue || '').trim()
    if (!value) return { title: '', category: '', unit: '' }

    const sep = ' - '
    const idx = value.lastIndexOf(sep)
    const title = idx === -1 ? value : value.slice(0, idx).trim()
    const category = idx === -1 ? '' : value.slice(idx + sep.length).trim()
    const unit = UNIT_BY_TITLE.get(title) || ''

    return { title, category, unit }
}

export default STANDARD_MATERIALS
